import React from "react";
import clsx from "clsx";

import styles from "./ToolTip.module.scss";

// ToolTip.module.scss の .multiline の max-width と合わせる
const TOOLTIP_MAX_WIDTH = 260;

export interface TooltipProps {
  children: React.ReactNode;
  content: string;
  placement?: "bottom" | "bottomLeft" | "right";
  multiline?: boolean;
  isEnabled?: boolean;
}

const findScrollParent = (element: HTMLElement): HTMLElement | null => {
  let parent = element.parentElement;
  while (parent) {
    const { overflowX } = window.getComputedStyle(parent);
    if (
      overflowX === "auto" ||
      overflowX === "scroll" ||
      overflowX === "hidden"
    ) {
      return parent;
    }
    parent = parent.parentElement;
  }
  return null;
};

const ToolTip = (props: TooltipProps) => {
  const containerRef = React.useRef<HTMLDivElement>(null);
  const [alignRight, setAlignRight] = React.useState(false);

  const handleMouseEnter = () => {
    if (props.placement === "right") {
      return;
    }
    const container = containerRef.current;
    if (!container) {
      return;
    }
    const boundRight =
      findScrollParent(container)?.getBoundingClientRect().right ??
      window.innerWidth;
    setAlignRight(
      container.getBoundingClientRect().left + TOOLTIP_MAX_WIDTH > boundRight,
    );
  };

  if (props.isEnabled === false) {
    return <>{props.children}</>;
  }

  return (
    <div
      ref={containerRef}
      className={clsx(
        styles.tooltipContainer,
        props.placement === "right" && styles.placementRight,
        props.placement === "bottomLeft" && styles.placementBottomLeft,
        props.multiline && styles.multiline,
        alignRight && styles.alignRight,
      )}
      data-tooltip={props.content}
      onMouseEnter={handleMouseEnter}
    >
      {props.children}
    </div>
  );
};

export default ToolTip;
